
<div class="leads-block-2026-container grid-cols-3 flex flex-row gap-4 background-medium-01 p-4">
<div>{{ 'home.my_potential_customers' | translate }}</div>
<div class="flex flex-row items-center gap-2 cursor-pointer" (click)="goToLeads('NEW')">
    <div class="typography-title-xl primaryDefault-color">{{leadsStats?.newCustomers}}</div>
    <div class="typography-body-s-light">{{'new' | translate}}</div>
</div>
<div class="dividerDivider"></div>

<div class="flex flex-row items-center gap-2 cursor-pointer" (click)="goToLeads('UNCONFIRMED')">
    <div class="typography-title-xl semanticDanger-color">{{leadsStats?.unconfirmed}}</div>
    <div class="typography-body-s-light">{{ 'home.not_confirmed' | translate }}</div>
</div>
<div class="dividerDivider"></div>
<div class="flex flex-row items-center gap-2 cursor-pointer" (click)="goToLeads('IN_PROGRESS')">
    <div class="typography-title-xl">{{leadsStats?.oppInProgress}}</div>
    <div class="typography-body-s-light">{{'home.in_process_leads' | translate}}</div>
</div>
<div class="dividerDivider"></div>
<div class="flex flex-row items-center gap-2 cursor-pointer" (click)="goToLeads('INCOMPLETED')">
    <div class="typography-title-xl">{{leadsStats?.almostComplete}}</div>
    <div class="typography-body-s-light"> {{ 'home.almost_complete' | translate }}</div>
</div>
<div class="dividerDivider"></div>

<app-link class="primaryDefault-color" (click)="goToLeads()">
    <div class="flex align-items-center">
{{ 'benefits_kb.loyalty_2026.manage' | translate }}
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 8L5.7998 4.93333L6.26647 4.46667L9.7998 8L6.26647 11.5333Z" fill="#365BCA"/>
</svg>
    </div>

    </app-link>
</div>


